import React from "react";
import "./DetailedInfoCard.css";
import { CTooltip } from "@coreui/react";
import InfoIcon from "../../../assets/icons/info.svg";
import { ReactComponent as RightArrow } from "../../../assets/icons/right-arrow.svg";

const DetailedInfoCard = ({
  title,
  stats,
  information,
  button_text,
  button_link,
  handleNavigation,
  show_link = true,
  spanText,
  style = {},
}) => {
  return (
    <div className="info-card" style={style}>
      <div className="d-flex justify-content-between ">
        <h6
          className="info-card-title"
          style={{ color: style?.color ? style?.color : "#64748b" }}
        >
          <strong>{title}</strong>
        </h6>
        <CTooltip content={information}>
          <img
            style={{ cursor: "pointer" }}
            src={InfoIcon}
            height="15px"
            width="15px"
            alt="Information Icon"
          />
        </CTooltip>
      </div>
      <h3
        className="primary-text pb-0"
        style={{
          textAlign: "start",
          color: style?.color ? style?.color : "#333",
        }}
      >
        {stats}
      </h3>
      {show_link && (
        <button
          onClick={() => {
            handleNavigation(button_link);
          }}
          className="link-button mb-2"
        >
          <small>{button_text}</small>
          <RightArrow
            src={RightArrow}
            alt=">"
            style={{
              marginLeft: "10px",
              marginTop: "2px",
              fill: "#b5c3cb",
              stroke: "#b5c3cb",
            }}
            height={"14px"}
            width={"14px"}
          />
        </button>
      )}
      <span
        className="text-muted"
        style={{
          textAlign: "start",
          color: style?.color ? style?.color : "#333",
          fontSize: "12px",
        }}
      >
        {spanText}
      </span>
    </div>
  );
};

export default DetailedInfoCard;
